// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3VXxx","content":"ManualTimeModal_content__3PNI1"};